import { useState } from 'react'
import AddNewAllergies from './AddNewAllergies';
const Allergies = ({ data, setIsRecordSaved, expandAll, ...props }) => {
    let { isViewAllowed, IsEditAllowed, IsDeleteAllowed } = props;
    const tabs = ['Drug', 'Food', 'Environment']
    const [activeTab, setActiveTab] = useState('Drug')
    const [expandItems, setExpandItems] = useState(true);
    const handleToggleExpand = () => {
        setExpandItems(prev => !prev);
    }
    const [isOpenAllergies, setIsOpenAllergies] = useState(false);
    const [allergiesID, setAllergiesID] = useState();
    const AddAllergies = (ID) => {
        if (!isViewAllowed) return;
        setAllergiesID(ID)
        setIsOpenAllergies(prev => !prev);
    }
    const CloseAllergies = () => {
        setIsOpenAllergies(false)
    }
    let PopupScreen = "";
    if (isOpenAllergies) {
        PopupScreen = <AddNewAllergies isOpenAllergies={isOpenAllergies} allergiesID={allergiesID} onClose={CloseAllergies} setIsRecordSaved={setIsRecordSaved} setAllergiesID={setAllergiesID}
            patientID={props?.patientID} IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed} />
    }
    return (
        <>
            {PopupScreen}
            <div className='content-box px-0'>
                <div className='d-flex align-items-center justify-content-between br-bottom-1 ar-light pb-1 mb-1 mx-2'>
                    <p className='cursor-pointer fs-13 heading user-select-none' onClick={handleToggleExpand}>Allergies</p>
                    <i className='icon-dash-plus fs-19' onClick={() => AddAllergies(null)}></i>
                </div>
                {/* {data?.length > 0 ?
                    <div className='d-flex align-items-center gap-12 mb-2 px-2'>
                        {tabs.map((tab, index) =>
                            <p className={`heading fs-10  ar-nav-link ${tab === activeTab && 'active'}`} key={index} onClick={() => setActiveTab(tab)}>
                                {tab}
                            </p>)}
                    </div> : null} */}
                {expandItems &&
                    expandAll &&
                    (data?.length > 0 ?
                        <div className='d-flex flex-column gap-2 problem-scroll hover-scrollbar px-2'>
                            {data.map(item => {
                                return (
                                    <div className='d-flex flex-column gap-1'>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <p className="text cursor-pointer" onClick={() => AddAllergies(item.PatientAllergyID)}><span className='validate-color'>{item.AllergyName}</span>({item.AllergyType})</p>

                                            {item.AllergyStatus === 'true' ?
                                                <p className='text Paid-clr fst-italic text-nowrap'>Active</p>
                                                :
                                                <p className='text Denied-clr fst-italic text-nowrap'>InActive</p>
                                            }
                                        </div>

                                        {item.Reaction ?
                                            <div className='d-flex align-items-center gap-1'>
                                                <p className='text font-m'>Reaction:</p>
                                                <p className='text'>{item.Reaction}</p>
                                            </div>
                                            : <></>}

                                        <div className="d-flex align-items-center justify-content-between">
                                            {item.OnSetDate ?
                                                <div className='d-flex align-items-center gap-1'>
                                                    <p className='text font-m'>Onset Date:</p>
                                                    <p className='text'>{item.OnSetDate}</p>
                                                </div>
                                                : <></>}
                                            {item.Severity ?
                                                <p className='heading orange-clr'>{item.Severity}</p>
                                                : <></>}
                                        </div>

                                        {/* <div className='d-flex align-items-center justify-content-between mb-2'>
                                            Reaction: <p className='text'>{item.Reaction}</p>
                                            <p className='text'>{item.OnSet} {item.OnSetDate ? `(${item.OnSetDate})` : null}</p>
                                            <p className='text orange-clr'>{item.Severity}</p>
                                        </div> */}
                                    </div>
                                )
                            })}
                        </div>
                        :
                        <></>)}
            </div>
        </>
    )
}
export default Allergies